import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

export default {
  consent_cyber_main: {
    required: helpers.withMessage(validationJson.club_consent_error, required),
    mustBeTrue: helpers.withMessage(
      validationJson.club_consent_error,
      Validator.mustBeTrue,
    ),
  },
  consent_cyber1: {
    required: helpers.withMessage(validationJson.club_consent_error, required),
    mustBeTrue: helpers.withMessage(
      validationJson.club_consent_error,
      Validator.mustBeTrue,
    ),
  },
  consent_cyber2: {
    required: helpers.withMessage(validationJson.club_consent_error, required),
    mustBeTrue: helpers.withMessage(
      validationJson.club_consent_error,
      Validator.mustBeTrue,
    ),
  },
  consent_cyber3: {
    required: helpers.withMessage(validationJson.club_consent_error, required),
    mustBeTrue: helpers.withMessage(
      validationJson.club_consent_error,
      Validator.mustBeTrue,
    ),
  },
};
